// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let V4 = require("uuid/v4");
let Attachments = require("../../../reason/common/Attachments/Attachments.bs.js");
let Stdlib_List = require("@rescript/runtime/lib/js/Stdlib_List.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let PropertyWizardUploads_draft_graphql = require("../../../__generated__/PropertyWizardUploads_draft_graphql.bs.js");

let convertFragment = PropertyWizardUploads_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardUploads_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardUploads_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardUploads_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardUploads_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function getAttachmentStatuses(attachments) {
  return Stdlib_Array.filterMap(attachments, attachment => {
    let match = attachment.state;
    switch (match.TAG) {
      case "InProgress" :
        return "InProgress";
      case "Failed" :
        return "Failed";
      case "NotStarted" :
      case "Success" :
        return;
    }
  });
}

function makeLocalScope() {
  return "local:" + V4();
}

function useIdentity(draft) {
  let serverDraftId = draft.serverDraftId;
  let scopeIdentity = React.useRef(serverDraftId !== undefined ? "server:" + serverDraftId : "local:" + V4());
  let lastServerDraftId = React.useRef(draft.serverDraftId);
  let match = lastServerDraftId.current;
  let match$1 = draft.serverDraftId;
  if (match !== undefined) {
    if (match$1 !== undefined) {
      if (match !== match$1) {
        scopeIdentity.current = "server:" + match$1;
        lastServerDraftId.current = match$1;
      }
    } else {
      scopeIdentity.current = "local:" + V4();
      lastServerDraftId.current = undefined;
    }
  } else if (match$1 !== undefined) {
    lastServerDraftId.current = match$1;
  }
  return scopeIdentity.current;
}

let DraftScope = {
  makeLocalScope: makeLocalScope,
  useIdentity: useIdentity
};

function PropertyWizardUploads$Inner(props) {
  let draft = props.draft;
  let updateDraftProperty = PropertyWizardFormRelay.useUpdateDraftProperty();
  let updateFormState = PropertyWizardFormRelay.FormState.useUpdater();
  let onUnsupportedFileError = Attachments.useUnsupportedFilesSystemMessage();
  let match = React.useState(() => draft.draftProperty.images.map(image => ({
    previewUrl: image.previewUrl,
    state: {
      TAG: "Success",
      _0: {
        id: image.id,
        key: image.key,
        fileName: image.fileName,
        contentType: image.contentType
      }
    }
  })));
  let match$1 = React.useState(() => draft.draftProperty.files.map(file => ({
    previewUrl: undefined,
    state: {
      TAG: "Success",
      _0: {
        id: file.id,
        key: file.key,
        fileName: file.fileName,
        contentType: file.contentType
      }
    }
  })));
  let updateImages = images => {
    let images$1 = Stdlib_List.toArray(images);
    let imagesReadyToSave = Stdlib_Array.filterMap(images$1, image => {
      let attachment = image.state;
      if (attachment.TAG === "Success") {
        return [
          image.previewUrl,
          attachment._0
        ];
      }
    });
    updateDraftProperty(localDraftProperty => {
      let newrecord = {...localDraftProperty};
      newrecord.images = imagesReadyToSave.map(param => {
        let attachment = param[1];
        return {
          contentType: attachment.contentType,
          fileName: attachment.fileName,
          id: attachment.id,
          key: attachment.key,
          previewUrl: param[0]
        };
      });
      return newrecord;
    });
    updateFormState(formState => {
      formState.imagesStatus = getAttachmentStatuses(images$1);
    });
  };
  let updateFiles = files => {
    let files$1 = Stdlib_List.toArray(files);
    let filesReadyToSave = Stdlib_Array.filterMap(files$1, file => {
      let attachment = file.state;
      if (attachment.TAG === "Success") {
        return attachment._0;
      }
    });
    updateDraftProperty(localDraftProperty => {
      let newrecord = {...localDraftProperty};
      newrecord.files = filesReadyToSave.map(attachment => ({
        contentType: attachment.contentType,
        fileName: attachment.fileName,
        id: attachment.id,
        key: attachment.key
      }));
      return newrecord;
    });
    updateFormState(formState => {
      formState.filesStatus = getAttachmentStatuses(files$1);
    });
  };
  let imagesManager = Attachments.useAttachments(updateImages, Stdlib_List.fromArray(match[0]), onUnsupportedFileError);
  let filesManager = Attachments.useAttachments(updateFiles, Stdlib_List.fromArray(match$1[0]), onUnsupportedFileError);
  return props.render({
    imagesManager: imagesManager,
    filesManager: filesManager
  });
}

let Inner = {
  make: PropertyWizardUploads$Inner
};

function PropertyWizardUploads(props) {
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardUploads_draft_graphql.node, convertFragment, props.draft);
  let draftScopeIdentity = useIdentity(draft);
  return JsxRuntime.jsx(PropertyWizardUploads$Inner, {
    draft: draft,
    render: props.render
  }, draftScopeIdentity);
}

let PropertyWizardForm;

let FormState;

let make = PropertyWizardUploads;

exports.PropertyWizardForm = PropertyWizardForm;
exports.FormState = FormState;
exports.DraftFragment = DraftFragment;
exports.getAttachmentStatuses = getAttachmentStatuses;
exports.DraftScope = DraftScope;
exports.Inner = Inner;
exports.make = make;
/* react Not a pure module */
